import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmMetadata } from "@natiwi/core/models/metadata";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";

export abstract class NatMetadataRepository<T extends OrmMetadata> extends NatCatalogRepository<T> {
    constructor(adapter?: NatRestAdapter) {
        super(adapter);
    }
}
